module.exports = require("./ja");